// import PDFViewer from '@tian-libs/pdfviewer'

export default defineNuxtPlugin(nuxtApp => {
    // try{
    //     nuxtApp.vueApp.use(PDFViewer)
    // }catch(e){
    //     alert(e)
    // }
})
